module.exports = __webpack_public_path__ + "static/media/logo.c7403569.svg";